import { render } from "./BillingAddressCheck.vue?vue&type=template&id=405b7e80&scoped=true"
import script from "./BillingAddressCheck.vue?vue&type=script&lang=js"
export * from "./BillingAddressCheck.vue?vue&type=script&lang=js"

import "./BillingAddressCheck.vue?vue&type=style&index=0&id=405b7e80&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405b7e80"]])

export default __exports__